import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import {
  BrowserRouter as Router,
  browserHistory,
  Switch,
  Route
} from 'react-router-dom'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import Home from './containers/Home'
import About from './containers/About'
import Careers from './containers/Careers'
import JobSpecification from './containers/JobSpecification'
import News from './containers/News'
import Framework42 from './containers/Framework42'
import MobileWKR from './containers/MobileWKR'
import Solutions from './containers/Solutions'
import Solution from './containers/Solution'
import NotFound from './containers/NotFound'
import Header from './components/Header'
import Bowser from 'bowser'
import ReactGA from 'react-ga'

import './styles/aircon-font.css'
import './styles/index.css'
import content from './site-content.js'

import load from 'little-loader'
load(
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyBrorJFTTqvBWk7h718LjskhV2t72dN094'
)

ReactGA.initialize('UA-6069564-6')

class ScrollToTop extends Component {
  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      const delay = 400
      setTimeout(() => window.scrollTo(0, 0), delay)
    }
  }
  componentDidMount () {
    /* eslint-disable */
    console.log(
      "%cHello! We hope you're enjoying looking behind the website. We love curious people. Here's something curious: 01010110 01100001 01101100 01110101 01100101 01110011. You should join us and help us build awesome stuff - http://www.bronzelabs.co.uk/careers",
      'color: #00b1ff; font-size: 16px'
    )
    /* eslint-enable */
    if (Bowser.msie && Bowser.version <= 9) {
      window.location = '/oldie.html'
    }
  }

  render () {
    return null
  }
}
ScrollToTop.propTypes = {
  location: PropTypes.any
}

class Analytics extends Component {
  componentDidMount () {
    ReactGA.set({ page: this.props.location.pathname })
    ReactGA.pageview(this.props.location.pathname)
  }
  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      ReactGA.set({ page: this.props.location.pathname })
      ReactGA.pageview(this.props.location.pathname)
    }
  }
  render () {
    return null
  }
}
Analytics.propTypes = {
  location: PropTypes.any
}

class Root extends Component {
  constructor () {
    super()
    this.setModal = this.setModal.bind(this)
    this.state = content
  }

  setModal (value) {
    if (value !== this.state.modalActive) {
      this.setState({ modalActive: value })
    }
  }

  render () {
    const {
      awards,
      news,
      jobs,
      solutions,
      tags,
      careerReasons,
      featureCards,
      featureVideos,
      f42Clients,
      mwkrClients,
      clients
    } = this.state
    /* eslint-disable */
    const transitionEnterTimeout = 800
    const transitionLeaveTimeout = 800
    return (
      <Router history={browserHistory}>
        <div>
          <Route
            render={({ location, history }) => (
              <CSSTransitionGroup
                transitionName={{
                  enter: 'enter',
                  enterActive: 'enterActive',
                  leave: 'leave',
                  leaveActive: 'leaveActive'
                }}
                transitionEnterTimeout={transitionEnterTimeout}
                transitionLeaveTimeout={transitionLeaveTimeout}
              >
                <ScrollToTop location={location} />
                <Analytics location={location} />
                <Switch location={location} key={location.key}>
                  <Route exact path="/" component={() => <Home />} />
                  <Route
                    exact
                    path="/about"
                    component={() => (
                      <About
                        setModal={this.setModal}
                        awards={awards}
                        news={news}
                        clients={clients}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/careers"
                    component={() => (
                      <Careers
                        setModal={this.setModal}
                        jobs={jobs}
                        careerReasons={careerReasons}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/careers/:job"
                    component={({ match }) => (
                      <JobSpecification
                        setModal={this.setModal}
                        jobs={jobs}
                        match={match}
                        history={history}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/news/:newsitem"
                    component={({ match }) => (
                      <News
                        setModal={this.setModal}
                        featureVideos={featureVideos}
                        news={news}
                        match={match}
                        history={history}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/framework42"
                    component={() => (
                      <Framework42
                        featureVideos={featureVideos}
                        clients={f42Clients}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/mobilewkr"
                    component={() => (
                      <MobileWKR
                        featureCards={featureCards}
                        featureVideos={featureVideos}
                        clients={mwkrClients}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/solutions"
                    component={() => (
                      <Solutions
                        setModal={this.setModal}
                        solutions={solutions}
                        tags={tags}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/solutions/:solution"
                    component={({ match }) => (
                      <Solution
                        setModal={this.setModal}
                        solutions={solutions}
                        match={match}
                        history={history}
                      />
                    )}
                  />
                  <Route component={NotFound} />
                </Switch>
                <Header
                  modal={this.state.modalActive}
                  history={history}
                  setModal={this.setModal}
                  toggleNavigation={this.toggleNavigation}
                />
              </CSSTransitionGroup>
            )}
          />
        </div>
      </Router>
    )
  }
}

ReactDOM.render(<Root />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js